import { Navigate , useLocation} from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("access_token");
  const location = useLocation();
  if (!token) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/handle/token?returnTo=${returnTo}`} />;
  }
  return children;
};

export default ProtectedRoute;
